import { render, staticRenderFns } from "./OPP.vue?vue&type=template&id=6831fa68"
import script from "./OPP.vue?vue&type=script&lang=js"
export * from "./OPP.vue?vue&type=script&lang=js"
import style0 from "./OPP.vue?vue&type=style&index=0&id=6831fa68&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports